<script setup lang="ts">
import { ImageLayoutSize } from '@xcel-next/core/enums'

import ImageSourceSet from '../../shared/image/SourceSet.vue'
import RecipeInterline from './RecipeInterline.vue'
import AdaSlotMarker from '../../ad-slots/AdaSlotMarker.vue'
import WakeLock from './WakeLock.vue'

import type { ImageParagraph } from '../../../utils/paragraph-schema/paragraphs'
import type { Brand } from '@xcel-next/core/enums'

type InstructionImage = NonNullable<ImageParagraph['image']>

type Instruction = {
  step?: { html?: string },
  image?: InstructionImage
}

type InstructionGroup = {
  name?: string,
  instructions: Instruction[]
}

withDefaults(defineProps<{
  instructionGroups?: InstructionGroup[],
  brand?: Brand,
  isPreview?: boolean
}>(), {
  instructionGroups: () => [],
  isPreview: false
})

const forceLacyLoading = 10

const imageLayoutClasses = (size?: ImageLayoutSize): string =>
  size?.length ? `bx-content--image-${size}` : ''
</script>

<template>
  <section class="bx-content bx-content__continuous-text bx-recipe__instructions bx-typo--content-continuous-text">
    <RecipeInterline title="Zubereitung"
                     variant="instruction" />
    <WakeLock />
    <div v-for="(instructionGroup, instructionGroupIndex) in instructionGroups"
         :key="'instructionGroups-' + instructionGroupIndex">
      <h3 v-if="instructionGroup.name"
          class="bx-instruction-group__title bx-typo--center bx-typo--h4">
        {{ instructionGroup.name }}
      </h3>
      <div v-for="(instruction, instructionIndex) in instructionGroup.instructions"
           :key="'instruction-' + instructionIndex">
        <!-- we need the ID to have a recipeIntruction url for structured data -->
        <span :id="`instructiongroup${instructionGroupIndex + 1}step${instructionIndex + 1}`"
              class="bx-instruction-group__instruction-step bx-typo--center">
          {{ instructionIndex + 1 }}
        </span>
        <div v-if="instruction.step?.html"
             v-html="instruction.step.html" />
        <div v-if="instruction.image?.imageId"
             :class="['bx-content__media', 'bx-typo--content-media', imageLayoutClasses(instruction.image.layout?.size)]">
          <ImageSourceSet :image="instruction.image"
                          :list-order-position="forceLacyLoading"
                          :is-preview="isPreview"
                          :brand="brand" />
        </div>
        <AdaSlotMarker v-bind="{ aboveParagraph: { index: 2, type: 'recipeInstructionGroup' } }" />
      </div>
    </div>
  </section>
</template>
